import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";

const EditNameModal = ({
  data,
  onClose,
  isLoading = false,
  isOpen = false,
  onSave,
}: {
  onClose: () => void;
  isOpen: boolean;
  data: {
    name?: string;
  };
  onSave: (props: { name: string }) => Promise<void>;
  isLoading: boolean;
}) => {
  const { register, handleSubmit } = useForm({
    mode: "all",
    criteriaMode: "all",
    reValidateMode: "onBlur",
    values: {
      name: data.name || "",
    },
  });

  return (
    <Modal
      size={"3xl"}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Event Name</ModalHeader>
        <ModalBody>
          <Input isDisabled={isLoading} {...register("name")} />
        </ModalBody>
        <ModalFooter>
          <Button
            isDisabled={isLoading}
            onClick={() => {
              onClose();
            }}
            mr="4"
          >
            Cancel
          </Button>
          <Button
            color="white"
            bg="green.500"
            isLoading={isLoading}
            onClick={handleSubmit(onSave)}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditNameModal;
